// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1233":"80f25013","1539":"716b0fd6","4561":"2ffd5df8","5361":"2ffd5df8","8556":"e2071b7a"}[chunkId] + ".css";
};